export const NPS_SCORES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export const TEST_COMMON_SURVEY_ID = 243657;
export const PROD_COMMON_SURVEY_ID = 244194;
export const TEST_TREND_SURVEY_ID = 243658;
export const PROD_TREND_SURVEY_ID = 244195;
